var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashierUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.25L11.0303 2.71967C10.8897 2.57902 10.6989 2.5 10.5 2.5C10.3011 2.5 10.1103 2.57902 9.96968 2.71967L10.5 3.25ZM13.9697 7.78033C14.2626 8.07322 14.7374 8.07322 15.0303 7.78033C15.3232 7.48744 15.3232 7.01256 15.0303 6.71967L13.9697 7.78033ZM9.75001 14.25C9.75001 14.6642 10.0858 15 10.5 15C10.9142 15 11.25 14.6642 11.25 14.25L9.75001 14.25ZM5.96967 6.71967C5.67678 7.01256 5.67678 7.48744 5.96967 7.78033C6.26256 8.07322 6.73744 8.07322 7.03033 7.78033L5.96967 6.71967ZM16.75 18.5C17.1642 18.5 17.5 18.1642 17.5 17.75C17.5 17.3358 17.1642 17 16.75 17L16.75 18.5ZM4.25 17C3.83579 17 3.5 17.3358 3.5 17.75C3.5 18.1642 3.83579 18.5 4.25 18.5L4.25 17ZM9.96968 3.78033L13.9697 7.78033L15.0303 6.71967L11.0303 2.71967L9.96968 3.78033ZM9.75001 3.25L9.75001 14.25L11.25 14.25L11.25 3.25L9.75001 3.25ZM9.96968 2.71967L5.96967 6.71967L7.03033 7.78033L11.0303 3.78033L9.96968 2.71967ZM16.75 17L4.25 17L4.25 18.5L16.75 18.5L16.75 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashierUploadIcon);
export default __webpack_public_path__ + "54795a5d8e0e3914d84916b283249762.svg";
export { ForwardRef as ReactComponent };